// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ClockIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="ClockIcon" ref={forwardedRef} {...props}>
      <path d="M8.502 6.498h1.5v3.5h2.5v1.5h-4z" />
      <path d="M1.996 10a8 8 0 1 0 16 0 8 8 0 0 0-16 0m8 6.5a6.5 6.5 0 1 1 0-13 6.5 6.5 0 0 1 0 13" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const ClockIcon = /* @__PURE__ */ Object.assign(ClockIconComponent, {
  displayName: 'ClockIcon',
});
